import styled from 'styled-components/macro'
import { Icon } from 'assets/Icons_'
import { active_project, iconRotate, iso_free, iso_isrotating, seasonMode, weaterMode } from 'state/store.global'
import { getFocus, useAtom, useGet, useSet } from 'state/jotai'
import { useBreak } from 'hooks/useBreak'
import { BREAK_ } from 'constants'
import { _project } from 'state/store.projects'

export const Back = ({}) => {
  const [rmode, setRmode] = useAtom(iso_free)
  const [isrotate, setIsrotate] = useAtom(iso_isrotating)
  const setSeasonMode = useSet(seasonMode);
  const setWeatherMode = useSet(weaterMode);
  const setIconRotated = useAtom(iconRotate)[1]

  const { pin, pid } = useGet(active_project) 
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const isMobile = useBreak('md_dn')
  const click = () => {
    setRmode(false)
    setIsrotate(false)
    setSeasonMode(false)
    setWeatherMode(false)
    setIconRotated(false)
  }


  return (
    <Box onClick={click}> 
      <Icon icon='back' size={isMobile ? '18' : '18'} color='#000' />
      <Text>{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'Tilbage')[0]?.Label }</Text>
    </Box>
  )
}

const Text = styled.div`
  white-space: nowrap;
  font-size: 18px;
  font-weight: 400px;  
  /* border: 1px solid black; */
`
const Box = styled.div`
  gap: 5px;
  cursor: pointer;
  padding: 5px 15px;
  z-index: 5;
  align-items: center;
  display: flex;
  gap:5px;
  user-select:none;
  ${ BREAK_.md_up } {
    position: absolute;
    // top: 105px;
    // left: 40px;
    top: 134px;
    left: 30px;
    padding:0;
  }
`